// A user-balanced rate with its 95% range over users: "55% (41–68%)".

import type { RateRange } from "../../types/talkTrack";
import { pct, rangeText } from "./format";

export function Rate({ value, range }: { value: number | null | undefined; range?: RateRange | null }) {
  const spread = value === null || value === undefined ? null : rangeText(range);
  return (
    <>
      {pct(value)}
      {spread && (
        <span className="muted tt-range" title="95% range over users: the mean of per-user rates ± 1.96 standard errors">
          {" "}({spread})
        </span>
      )}
    </>
  );
}
